// extracted by mini-css-extract-plugin
export default {"menuPaper":"menuPaper--nCG61"};